import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect, useRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FacebookShareButton, PinterestShareButton, TwitterShareButton } from 'react-share';
import VisualizerEmailModal from '../VisualizerEmailModal/VisualizerEmailModal';
import { IconShare, IconTwitter, IconFacebook, IconPinterest, IconMail, IconSms, IconCopy } from '../Icons';

import { getThumbnailUrl, getVisualizerNoun } from '../../Utils/VisualizerUtils';

import { ShareDropdownWrapper } from './ShareDropdownStyles';

var _ref3 = React.createElement(IconShare, null);

var _ref4 = React.createElement(IconSms, null);

var _ref5 = React.createElement(IconMail, null);

var _ref6 = React.createElement(IconPinterest, null);

var _ref7 = React.createElement(IconFacebook, null);

var _ref8 = React.createElement(IconTwitter, null);

var _ref9 = React.createElement(IconCopy, null);

var ShareDropdown = function ShareDropdown(_ref) {
  var relativeUrl = _ref.relativeUrl,
      buttonColor = _ref.buttonColor,
      _ref$withIcon = _ref.withIcon,
      withIcon = _ref$withIcon === undefined ? true : _ref$withIcon,
      selectedProducts = _ref.selectedProducts;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showShareDropdown = _useState2[0],
      setShowShareDropdown = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showEmailModal = _useState4[0],
      setShowEmailModal = _useState4[1];

  var shareDropdownRef = useRef(null);

  var handleOutsideClick = function handleOutsideClick(e) {
    // ignore clicks on the component itself
    if (shareDropdownRef.current.contains(e.target)) {
      return;
    }
    // else close dropdown
    setShowShareDropdown(false);
  };

  var copyShareUrl = function copyShareUrl(shareUrl) {
    var dummyInput = document.createElement('input');
    document.body.appendChild(dummyInput);
    dummyInput.value = shareUrl;
    dummyInput.select();
    document.execCommand('copy');
    document.body.removeChild(dummyInput);
    alert('Link has been copied to your clipboard');
  };

  useEffect(function () {
    var preFetchThumbnailImg = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(getThumbnailUrl({ relativeUrl: relativeUrl, encodeDormifyUrl: true }));

              case 2:
                return _context.abrupt('return', null);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function preFetchThumbnailImg() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (showShareDropdown) {
      // prefetch and add click event
      preFetchThumbnailImg();
      document.addEventListener('click', handleOutsideClick, false);
    } else {
      // remove click event
      document.removeEventListener('click', handleOutsideClick, false);
    }
    return function () {
      // clean up
      document.removeEventListener('click', handleOutsideClick, false);
    };
  }, [showShareDropdown, relativeUrl]);
  var pathName = relativeUrl.split('?')[0];
  var shareUrl = 'https://visualizer.dormify.com' + pathName + '?url=https://www.dormify.com' + relativeUrl;
  var shareText = 'Check out the ' + getVisualizerNoun().toLowerCase() + ' I designed on Dormify.com!';
  var smsText = encodeURIComponent('Check out the ' + getVisualizerNoun().toLowerCase() + ' I designed on Dormify!\n\n' + shareUrl);
  return React.createElement(
    Fragment,
    null,
    React.createElement(
      ShareDropdownWrapper,
      { ref: shareDropdownRef, buttonColor: buttonColor },
      React.createElement(
        'button',
        { onClick: function onClick() {
            return setShowShareDropdown(!showShareDropdown);
          } },
        withIcon && _ref3,
        'Share'
      ),
      showShareDropdown && React.createElement(
        'ul',
        null,
        React.createElement(
          'li',
          null,
          React.createElement(
            'a',
            { href: 'sms:?&body=' + smsText },
            _ref4
          )
        ),
        React.createElement(
          'li',
          null,
          React.createElement(
            'button',
            { onClick: function onClick() {
                return setShowEmailModal(true);
              } },
            _ref5
          )
        ),
        React.createElement(
          'li',
          null,
          React.createElement(
            PinterestShareButton,
            {
              url: shareUrl,
              description: shareText,
              media: getThumbnailUrl({ relativeUrl: relativeUrl })
            },
            _ref6
          )
        ),
        React.createElement(
          'li',
          null,
          React.createElement(
            FacebookShareButton,
            { quote: shareText, url: shareUrl },
            _ref7
          )
        ),
        React.createElement(
          'li',
          null,
          React.createElement(
            TwitterShareButton,
            { title: shareText, url: shareUrl },
            _ref8
          )
        ),
        React.createElement(
          'li',
          null,
          React.createElement(
            'button',
            {
              onClick: function onClick() {
                return copyShareUrl('https://www.dormify.com' + relativeUrl);
              }
            },
            _ref9
          )
        )
      )
    ),
    showEmailModal && React.createElement(VisualizerEmailModal, {
      active: showEmailModal,
      closeModalFunc: function closeModalFunc() {
        return setShowEmailModal(false);
      },
      selectedProducts: selectedProducts,
      relativeUrl: relativeUrl
    })
  );
};

ShareDropdown.propTypes = {
  relativeUrl: PropTypes.string.isRequired,
  buttonColor: PropTypes.string,
  withIcon: PropTypes.bool,
  selectedProducts: PropTypes.array.isRequired
};

export default ShareDropdown;